import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { LashesBrows } from '../components/LashesBrows';
import { Masterclass } from '../components/Masterclass';
import { Team } from '../components/Team';
import { Testimonials } from '../components/Testimonials';
import { InstagramFeed } from '../components/InstagramFeed';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
export function Home() {
  return <div className="min-h-screen bg-cream selection:bg-rosegold/30" data-id="element-285">
      <Navbar data-id="element-286" />
      <main data-id="element-287">
        <Hero data-id="element-288" />
        <About data-id="element-289" />
        <Services data-id="element-290" />
        <InstagramFeed data-id="element-291" />
        <LashesBrows data-id="element-292" />
        <Masterclass data-id="element-293" />
        <Team data-id="element-294" />
        <Testimonials data-id="element-295" />
        <Contact data-id="element-296" />
      </main>
      <Footer data-id="element-297" />
      <FloatingWhatsApp data-id="element-298" />
    </div>;
}